import { Person, Description, Edit, Download, CheckCircle } from '@mui/icons-material';
import { Theme } from '@mui/material/styles';
import dayjs from 'dayjs';

/**
 * Returns the appropriate icon component based on the notification message content
 */
export const getNotificationIcon = (message: string, iconColor: string) => {
    const messageLower = message.toLowerCase();
    if (messageLower.includes('assigned') || messageLower.includes('activated') || messageLower.includes('approve')) {
        return <Person sx={{ fontSize: '20px', color: iconColor }} />;
    }
    if (messageLower.includes('created') || messageLower.includes('record')) {
        return <Description sx={{ fontSize: '20px', color: iconColor }} />;
    }
    if (messageLower.includes('field') || messageLower.includes('updated')) {
        return <Edit sx={{ fontSize: '20px', color: iconColor }} />;
    }
    if (messageLower.includes('download') || messageLower.includes('invoice')) {
        return <Download sx={{ fontSize: '20px', color: iconColor }} />;
    }
    return <CheckCircle sx={{ fontSize: '20px', color: iconColor }} />;
};

/**
 * Returns the color for the status dot based on notification read status, importance, and priority
 */
export const getStatusDotColor = (isRead: boolean, isImportant: boolean, priority: number, theme: Theme): string => {
    if (isRead) return 'transparent';
    if (isImportant) return theme.palette.error.main;
    switch (priority) {
        case 5:
            return theme.palette.error.main;
        case 4:
            return theme.palette.warning.main;
        default:
            return 'transparent';
    }
};

/**
 * Formats a timestamp to a time string in 'hh:mmA' format
 */
export const formatTime = (timestamp: number): string => dayjs(timestamp).format('hh:mmA');
